/**
 * Parse a YouTube URL in any of the supported formats and return the 11-char
 * video id, or null if the URL is not recognised as YouTube.
 *
 * Accepted formats:
 *   https://www.youtube.com/watch?v=VIDEO_ID
 *   https://www.youtube.com/watch?v=VIDEO_ID&t=42
 *   https://youtu.be/VIDEO_ID
 *   https://youtu.be/VIDEO_ID?t=42
 *   https://www.youtube.com/embed/VIDEO_ID
 *   https://www.youtube.com/shorts/VIDEO_ID
 *   https://m.youtube.com/watch?v=VIDEO_ID
 *   VIDEO_ID  (raw 11-char id)
 */
export function parseYouTubeId(input) {
  if (!input || typeof input !== "string") return null;
  const s = input.trim();
  // Bare id
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  let url;
  try { url = new URL(s); } catch { return null; }
  const host = url.hostname.replace(/^www\./, "").replace(/^m\./, "");
  if (host === "youtu.be") {
    const id = url.pathname.slice(1).split("/")[0];
    return /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
  }
  if (host === "youtube.com" || host === "youtube-nocookie.com") {
    if (url.pathname === "/watch") {
      const id = url.searchParams.get("v");
      return /^[A-Za-z0-9_-]{11}$/.test(id || "") ? id : null;
    }
    const m = url.pathname.match(/^\/(embed|shorts|v)\/([A-Za-z0-9_-]{11})/);
    if (m) return m[2];
  }
  return null;
}

export function youtubeEmbedUrl(input) {
  const id = parseYouTubeId(input);
  return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
}

export function youtubeThumbnailUrl(input) {
  const id = parseYouTubeId(input);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}
